import { Box, IconButton, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { getFromStorage } from '../utils/storage'
import { useDispatch, useSelector } from 'react-redux'
import { updateFormActions } from '../redux/store'
import Loading from './Loading'
import { socket } from '../utils/socket'
import DeleteIcon from '@mui/icons-material/Delete'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import LoopIcon from '@mui/icons-material/Loop'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import ContentCutIcon from '@mui/icons-material/ContentCut'
import { mainRed, mainBlue, mainPurple } from '../utils/color'
import TagModal from './TagModal'
import { orderPanelStyles } from './common/orderPanelStyles'
import ExtendedIconButton from './button-icons/ExtendedIconButton'
import PanelOrderItem from './PanelOrderItem'
import { enqueueSnackbar } from 'notistack'

export default function ProduceOrderPanel({ produceOrdersProps, handleStartShippingOrdersProps }) {
	const dispatch = useDispatch()
	const token = getFromStorage('current-user')?.accessToken
	const { isLoading } = useSelector((state) => state.isLoading)
	const { currentUser } = useSelector((state) => state.currentUser)

	const [currentTagItem, setCurrentTagItem] = useState(null)
	const messagesEndRef = useRef(null)
	const [handleStartShippingOrders, setHandleStartShippingOrders] = useState(produceOrdersProps)
	const [expandedOrders, setExpandedOrders] = useState({})

	// Scroll to bottom
	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'instant' })
	}

	useEffect(() => {
		scrollToBottom()
	}, [])

	useEffect(() => {
		setHandleStartShippingOrders(produceOrdersProps)
	}, [produceOrdersProps])

	// Tag handlers
	const handleTagClick = (item) => {
		console.log(item)
		setCurrentTagItem(item)
	}

	//------POST END PRODUCE ORDERS------
	const endProduceOrder = async function (data) {
		socket.emit('post-end-produce-order', data)
	}

	//------POST END OTHER PRODUCE ORDERS------
	const endOtherProduceOrder = async function (data) {
		socket.emit('post-end-other-produce-order', data)
	}

	//------POST WAIT CONFIRM DELETE ORDER------
	const waitConfirmDeleteOrder = async function (data) {
		socket.emit('wait-confirm-delete-order', data)
	}

	const startShipOrder = async function (data) {
		socket.emit('post-start-ship-order', data)
	}

	if (isLoading) return <Loading />

	return (
		<Box overflow='auto' sx={orderPanelStyles.container}>
			<Box sx={orderPanelStyles.ordersBox}>
				{handleStartShippingOrders?.map((order, serviceIndex) => (
					<PanelOrderItem
						key={order._id}
						order={order}
						expandedOrders={expandedOrders}
						renderActions={() => {
							return (
								<>
									{order.status !== 'pending-delete-produce' && order.status !== 'confirm-delete-produce' && (
										<Box sx={orderPanelStyles.actionIcons}>
											{order.producer?.user?._id === currentUser.id &&
												!order.producer?.produceEnd &&
												currentUser.permission?.includes('completeProduce') && (
													<IconButton
														onClick={(e) => {
															e.stopPropagation()
															endProduceOrder({
																orderId: order._id,
																store: currentUser?.store,
																accessToken: token,
																serviceIndex,
															})
														}}
														size='small'
														sx={{ color: mainBlue }}>
														<LoopIcon fontSize='small' />
													</IconButton>
												)}

											{order.producer?.user?._id !== currentUser.id &&
												!order.producer?.produceEnd &&
												!order?.quickPurchase &&
												currentUser.permission?.includes('completeOtherProduce') && (
													<IconButton
														onClick={(e) => {
															e.stopPropagation()
															endOtherProduceOrder({
																orderId: order._id,
																store: currentUser?.store,
																accessToken: token,
																serviceIndex,
															})
														}}
														size='small'
														sx={{ color: mainBlue }}>
														<LoopIcon fontSize='small' />
													</IconButton>
												)}

											{currentUser.permission?.includes('receiveDelivery') &&
												order.producer.produceEnd &&
												!order?.quickPurchase && (
													<IconButton
														onClick={(e) => {
															e.stopPropagation()
															startShipOrder({
																orderId: order._id,
																shipId: currentUser?.id,
																store: currentUser.store,
																accessToken: token,
															})
														}}
														size='small'
														sx={{ color: mainBlue }}>
														<LocalShippingIcon fontSize='small' />
													</IconButton>
												)}

											{currentUser.permission?.includes('updateOrder') && (
												<IconButton
													size='small'
													onClick={(e) => {
														e.stopPropagation()
														const payload = {
															...order,
															serviceIndex,
														}
														dispatch(updateFormActions.editOrder(payload))
														dispatch(updateFormActions.showUpdateForm())
													}}
													sx={{ color: mainPurple }}>
													<ContentCutIcon fontSize='small' />
												</IconButton>
											)}

											{currentUser.permission?.includes('updateTag') && (
												<IconButton
													size='small'
													onClick={(e) => {
														e.stopPropagation()
														handleTagClick(order)
													}}
													sx={{ color: mainBlue }}>
													<LocalOfferIcon
														sx={{
															color: '#4CAF50',
															transform: 'rotate(90deg)',
														}}
														fontSize='small'
													/>
												</IconButton>
											)}

											{currentUser.permission?.includes('deleteOrder') && (
												<IconButton
													size='small'
													onClick={(e) => {
														e.stopPropagation()
														const deleteReason = window.prompt('Nhập lý do hủy')
														if (!deleteReason || deleteReason.trim() === '') {
															alert('Lý do hủy không được để trống!')
														} else {
															waitConfirmDeleteOrder({
																deletor: currentUser.id,
																storeId: currentUser.store,
																orderId: order._id,
																accessToken: token,
																deleteReason,
																serviceIndex,
															})
															enqueueSnackbar('Chờ xác nhận xóa đơn hàng!')
														}
													}}
													sx={{ color: mainRed }}>
													<DeleteIcon fontSize='small' />
												</IconButton>
											)}

											{(order?.source || order?.code) && (
												<ExtendedIconButton
													isExpanded={expandedOrders[order._id]}
													onClick={() => setExpandedOrders((prev) => ({ ...prev, [order._id]: !prev[order._id] }))}
												/>
											)}
										</Box>
									)}
								</>
							)
						}}
					/>
				))}
			</Box>

			{produceOrdersProps?.length === 0 && handleStartShippingOrdersProps?.length === 0 && (
				<Typography variant='h6' sx={orderPanelStyles.emptyMessage}>
					Chưa có đơn hàng đang soạn
				</Typography>
			)}

			<Box ref={messagesEndRef} />

			{currentTagItem ? (
				<TagModal open={!!currentTagItem} onClose={() => setCurrentTagItem(null)} currentItem={currentTagItem} />
			) : null}
		</Box>
	)
}
